"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shortcut_plugin_1 = require("./shortcut-plugin");
function inlineLeafShortcut(regexp, name, config) {
    return new shortcut_plugin_1.TextShortcut(name, regexp, function (view, state, match, start, end) {
        var nodeType = state.schema.nodes[name];
        if (!nodeType)
            return null;
        var attrs = shortcut_plugin_1.getShortcutAttrs(config.handler, view, match, start, end);
        if (!attrs)
            return null;
        return state.tr.replaceWith(start, end, nodeType.create(attrs));
    }, config);
}
exports.inlineLeafShortcut = inlineLeafShortcut;
//# sourceMappingURL=inline-leaf-shortcut.js.map